import React from 'react';
import { translate } from '../../Services/translation';
import Product from '../../Types/Product';
import clsx from 'clsx';
import html2canvas from 'html2canvas';
import Icon from '../Icon';
import { SimulatorRoom } from '../../Types/SimulatorRoom';

interface ActionButtonInterface {
  activeProduct?: Product;
  linkCopied?: boolean;
  setLinkCopied: (linkCopied: boolean) => void;
  selectedRoom: SimulatorRoom;
}
const createDownloadableImageCanvas = (
  activeProduct: Product,
  selectedRoom
) => {
  // Create the wrapping div element that contains the background image (wallpaper) and position it offscreen
  var tempDivCanvas = document.createElement('div');
  tempDivCanvas.id = 'downloadable-canvas';
  tempDivCanvas.style.backgroundImage = `url("${
    activeProduct?.simulatorGeneratedImageUrl ?? ''
  }")`;
  tempDivCanvas.style.backgroundSize = `calc(60% * ${
    selectedRoom.roomZoomMultiplier ? selectedRoom.roomZoomMultiplier : 1
  })`;
  tempDivCanvas.style.position = 'absolute';
  tempDivCanvas.style.left = '-10000px';
  tempDivCanvas.style.top = '-10000px';
  tempDivCanvas.className =
    'grid aspect-[675/900] w-[1080px] grid-cols-1 overflow-hidden rounded object-cover';

  // Create the overlay room image element
  var tempRoomImage = document.createElement('img');
  tempRoomImage.src = selectedRoom.roomImage.sizeDefinitions[0].url;
  (tempRoomImage.className =
    'rounded col-start-1 row-start-1 z-10 object-cover h-full'),
    tempDivCanvas.appendChild(tempRoomImage);
  document.body.appendChild(tempDivCanvas);
};

const WallpaperSimulatorActionButtons = ({
  activeProduct,
  linkCopied,
  setLinkCopied,
  selectedRoom,
}: ActionButtonInterface) => {
  const handleDownloadImageClick = () => {
    if (!activeProduct) return;
    createDownloadableImageCanvas(activeProduct, selectedRoom);
    let canvasElement = document.getElementById('downloadable-canvas');
    html2canvas(canvasElement as HTMLElement).then((canvas) => {
      const base64img = canvas.toDataURL('image/png');
      var a = document.createElement('a');
      a.href = base64img;
      a.download = `${activeProduct?.name}-preview.png`;
      a.click();
      a.remove();
    });
    canvasElement?.remove();
  };

  const handleCopyLinkClick = () => {
    if (!activeProduct) return;
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl);
    setLinkCopied(true);
  };
  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-1 gap-3 store-screen:hidden lg:grid-cols-2">
        <button
          className={clsx(
            'btn btn--large bg-white',
            activeProduct
              ? 'border-gray-900'
              : '!cursor-default !border-gray-700 !text-gray-700 opacity-50'
          )}
          onClick={() => handleCopyLinkClick()}
        >
          {linkCopied ? (
            <>
              <Icon name="copy-icon" className="mr-3 h-4 w-4" />
              {translate('simulator.link-copied')}{' '}
              <Icon name="check" className="ml-1 h-4 w-4" />
            </>
          ) : (
            <>
              <Icon name="copy-icon" className="mr-3 h-4 w-4" />
              {translate('simulator.copy-link')}
            </>
          )}
        </button>
        <button
          className={clsx(
            'btn btn--large bg-white',
            activeProduct
              ? 'border-gray-900'
              : '!cursor-default !border-gray-700 !text-gray-700 opacity-50'
          )}
          onClick={() => handleDownloadImageClick()}
        >
          <Icon name="download" className="mr-3 h-4 w-4" />
          {translate('simulator.download-image')}
        </button>
      </div>
      {activeProduct ? (
        <a
          href={activeProduct.url}
          className="btn btn--black btn--large btn--fullwidth"
        >
          {translate('simulator.go-to-product')}
          <Icon name="chevron-right" className="ml-2 h-4 w-4" />
        </a>
      ) : (
        <div className="btn btn--large btn--disabled btn--fullwidth !cursor-default bg-gray-700 text-white opacity-50">
          {translate('simulator.go-to-product')}
          <Icon name="chevron-right" className="ml-2 h-4 w-4" />
        </div>
      )}
    </div>
  );
};

export default WallpaperSimulatorActionButtons;
